import { StyledButton } from "@tiendeo/react-components/dist/objects/Buttons/StyledButton";
import { HeadSmall, TextMedium } from "@tiendeo/react-components/dist/Typography";
import styled from "styled-components";
import Button from "ui/components/Button/Button";

export const BannerContent = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        margin-left: ${(props) => props.theme.spacing.sm};
        justify-content: end;
        margin-top: 0;
    }
`;

export const ButtonWrapper = styled.div`
    max-width: 400px;
    display: flex;
    align-self: flex-end;
    margin-top: ${(props) => props.theme.spacing.sm};
`;

export const NotificationsList = styled.div`
    display: flex;
    flex-direction: column;
    margin: 20px;
    media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        margin: 0;
    }
`;

export const FullPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;

    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        flex-direction: row;
    }
`;

export const InfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const NotificationsMessage = styled.div`
    display: flex;
    flex-direction: row;
    margin: ${(props) => props.theme.spacing.sm} 0;
    border: 1px solid red;
    padding: 12px;
    border-radius: 8px;
`;

export const SelectAll = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 12px;
    margin-top: 12px;
`;

export const Notification = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 12px;
    padding: ${(props) => props.theme.spacing.xs} 0;
    border-bottom: 0.5px solid ${(props) => props.theme.colors.secondary.secondary200};
`;

export const NotificationInput = styled.input`
    height: 12px;
    width: 12px;
    margin-right: ${(props) => props.theme.spacing.sm};

    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        height: 14px;
        width: 14px;
    }
`;
export const NewsletterInput = styled(NotificationInput as any)`
    min-height: 14px;
    min-width: 14px;
    margin-right: 12px;
`;

export const NewsletterCheck = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 12px;
    margin-bottom: 12px;
`;

export const MoreNotificationsAndManagement = styled.div`
    display: flex;
    flex-direction: column;

    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        flex-direction: row;
    }
`;

export const MoreNotificationsHead = styled(HeadSmall as any)`
    margin: ${(props) => props.theme.spacing.sm} 0;
    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        margin: 0;
    }
`;

export const DataManagementHead = styled(HeadSmall as any)`
    margin: ${(props) => props.theme.spacing.sm} 0;
    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        margin: 0;
    }
`;

export const MoreNotificationsButton = styled(Button as any)`
    margin: ${(props) => props.theme.spacing.sm} 0;
    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        margin: 0;
    }
`;

export const DataManagementButton = styled(Button as any)`
    margin: ${(props) => props.theme.spacing.sm} 0;
    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        margin: 0;
    }
`;

export const MoreNotifications = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin: ${(props) => props.theme.spacing.sm};

    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        margin-right: ${(props) => props.theme.spacing.xxl};
        height: 200px;
        width: 350px;
    }
`;

export const DataManagement = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin: ${(props) => props.theme.spacing.sm};
    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        height: 200px;
        width: 350px;
    }
`;

export const StyledButtonDelete = styled(StyledButton as any)`
    &:disabled {
        background-color: gray;
        cursor: not-allowed;
    }
`;
